import { Modal } from '@cfs-fixings/shared'
import { ProjectResource } from '@/api/serverApi'
import UpdateProjectForm from '../../forms/projects/UpdateProjectForm'

const textSpec = {
  title: 'Rename Project',
}

type PropTypes = {
  isOpen: boolean
  project?: ProjectResource
  onSuccess?: (project: ProjectResource) => void
  onClose: () => void
}

const UpdateProjectModal = ({ isOpen, project, onSuccess, onClose }: PropTypes) => {
  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      title={textSpec.title}
      content={
        project
          ? (
            <UpdateProjectForm
              project={project}
              onCompleted={(project) => {
                onSuccess?.(project)
                onClose()
              }}
              onClose={onClose}
            />
          )
          : <></>
      }
    />
  )
}

export default UpdateProjectModal
